import { Injectable } from '@angular/core';
import { Effect, ofType, Actions } from '@ngrx/effects';
import {
  getIntegrationsAction,
  getIntegrationsSuccessAction,
  getIntegrationsFailAction,
  getIntegrationFailAction,
  getIntegrationSuccessAction,
  getIntegrationAction,
  getAccountIntegrationsAction,
  getAccountIntegrationsSuccessAction,
  getAccountIntegrationsFailAction,
} from './integrations.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class IntegrationsEffects {
  @Effect()
  getIntegrations$ = this.actions$.pipe(
    ofType(getIntegrationsAction),
    switchMap(() =>
      this.integrationsService.getIntegrations().pipe(
        map((response) =>
          getIntegrationsSuccessAction({ integrations: response }),
        ),
        catchError(() => {
          this.toastr.error('Could not fetch integrations', 'Request failed');
          return [getIntegrationsFailAction()];
        }),
      ),
    ),
  );

  @Effect()
  getIntegration$ = this.actions$.pipe(
    ofType(getIntegrationAction),
    switchMap((action) =>
      this.integrationsService.getIntegration(action.id).pipe(
        map((response) =>
          getIntegrationSuccessAction({ integration: response }),
        ),
        catchError(() => {
          this.toastr.error('Could not fetch integration', 'Request failed');
          return [getIntegrationFailAction()];
        }),
      ),
    ),
  );

  @Effect()
  getAccountIntegrations$ = this.actions$.pipe(
    ofType(getAccountIntegrationsAction),
    switchMap((action) =>
      this.integrationsService.getAccountIntegrations(action.accountId).pipe(
        map((response) =>
          getAccountIntegrationsSuccessAction({
            accountIntegrations: response,
          }),
        ),
        catchError(() => {
          this.toastr.error(
            'Could not fetch account integrations',
            'Request failed',
          );
          return [getAccountIntegrationsFailAction()];
        }),
      ),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly toastr: ToastrService,
    private readonly integrationsService: ApiService,
  ) {}
}
